import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { PHONE_LINK } from "@/components/Ui";

export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-2 border-t border-white/10" data-testid="mobile-cta-bar">
      <a href={PHONE_LINK} className="flex items-center justify-center gap-2 bg-[#C4A484] text-[#0A0A0A] py-4 text-sm font-semibold" data-testid="mobile-call-button">
        <Phone size={16} /> Appeler
      </a>
      <Link to="/contact" className="flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#F5F5F0] py-4 text-sm font-semibold" data-testid="mobile-devis-button">
        <FileText size={16} /> Devis gratuit
      </Link>
    </div>
  );
}
